import { ChangeDetectionStrategy, Component } from "@angular/core";
import { DashboardRecommendedListsDataResponseDto } from "src/app/shared/dto/dashboard-recommended-lists-data.dto";
import { ResultTabsetUrlsEnum } from "src/app/shared/enums";
import { UniversalSearchModel, UniversalSearchModelType } from 'src/app/core/models/universal-search.model';
import { AuthenticationService } from "src/app/core/services";
import { cloneDeep } from 'lodash-es';
import { RECOMMENDED_LISTS_DATA } from "../../constants/recommended-lists-data.const";
import { ReportingDashboardService } from '../../services';

@Component({
    selector: 'app-recommended-lists-card',
    templateUrl: './recommended-lists-card.component.html',
    styleUrls: ['./recommended-lists-card.component.scss', '../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RecommendedListsCardComponent {
    rankingData: DashboardRecommendedListsDataResponseDto[] = RECOMMENDED_LISTS_DATA;

    readonly resultTabsetUrlsEnum: typeof ResultTabsetUrlsEnum = ResultTabsetUrlsEnum;

    constructor(
        private auth: AuthenticationService,
        private readonly reportingDashboardService: ReportingDashboardService,
    ) { }

    onSearchRanking(id) {
        const searchModelData = {
            ...cloneDeep(UniversalSearchModel),
            rankings: {[id]: true},
            request_type: 'COMPANIES',
            page: 1,
            verified: 1,
            tiers: this.auth.getHumanVerifiedTiers().toString(),
        } as UniversalSearchModelType;
        this.reportingDashboardService.onReportingDashboardSearch(searchModelData)
    }
}
